var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('ReportTypeFilter')],1),_c('div',{staticClass:"column is-6"},[_c('AnalysisTypeFilter',{key:String(_vm.reportTypeDetailStore.reportTypeId)})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }